/*
 * Client pickers in Billing (QA batch 17, PAY-009): the server's client search
 * also matches addresses / phone numbers, so "123" listed clients like "North
 * Vancouver" first. Names that match go first: exact, then starting with the
 * text, then a word starting with it, then containing it; the server's order
 * is kept inside each group and for the rest.
 */

const normalize = (text: string | null | undefined) =>
  (text || "").toLowerCase().replace(/\s+/g, " ").trim();

export const clientMatchRank = (name: string, query: string): number => {
  const q = normalize(query);
  const n = normalize(name);
  if (!q) return 0;
  if (n === q) return 0;
  if (n.startsWith(q)) return 1;
  if (n.split(/[\s\-.,&()/]+/).some((word) => word.startsWith(q))) return 2;
  if (n.includes(q)) return 3;
  return 4;
};

export const rankClientOptions = <T extends { label: string }>(
  options: T[],
  query: string,
): T[] =>
  options
    .map((option, index) => ({
      option,
      index,
      rank: clientMatchRank(option.label, query),
    }))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map((item) => item.option);
